module.exports = __webpack_public_path__ + "static/media/blockedUsers.9cbf14f8.svg";